if (!customElements.get("component-tabs")) {
  class Tabs extends HTMLElement {
    connectedCallback() {
      const raw = this.getAttribute("data-initial-tab-index");
      const parsed = raw === null || raw === "" ? 0 : parseInt(raw, 10);
      const initialIndex = Number.isNaN(parsed) ? 0 : parsed;
      this.tabs(".tabs__btn", ".tabs__content", "show", "active", initialIndex);
      this.onBlockSelect = this.handleBlockSelect.bind(this);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.onBlockSelect) {
        document.removeEventListener("shopify:block:select", this.onBlockSelect);
      }
    }

    tabs(btnSelector, contentSelector, contentActiveClass, btnActiveClass, initialIndex = 0) {
      const tabs = this.querySelectorAll(btnSelector);
      const tabsContent = this.querySelectorAll(contentSelector);

      if (!tabs.length || !tabsContent.length) return;

      const maxIndex = tabs.length - 1;
      const safeInitial = Math.min(Math.max(0, initialIndex), maxIndex);

      function hideTabs() {
        tabsContent.forEach((item) => {
          item.classList.remove(contentActiveClass);
          item.setAttribute("aria-hidden", "true");
        });

        tabs.forEach((tab) => {
          tab.classList.remove(btnActiveClass);
          tab.setAttribute("aria-expanded", "false");
        });
      }

      function showTabs(i = 0) {
        if (!tabsContent[i] || !tabs[i]) return;
        tabsContent[i].classList.add(contentActiveClass);
        tabsContent[i].setAttribute("aria-hidden", "false");
        tabs[i].classList.add(btnActiveClass);
        tabs[i].setAttribute("aria-expanded", "true");
      }

      hideTabs();
      showTabs(safeInitial);

      tabs.forEach((tab, i) => {
        tab.addEventListener("click", () => {
          hideTabs();
          showTabs(i);
        });
      });
    }

    handleBlockSelect(event) {
      const blockId = event?.detail?.blockId;
      if (!blockId) return;

      const tabButton = this.querySelector(`.tabs__btn[data-block-id="${blockId}"]`);
      if (!tabButton) return;

      tabButton.click();
      tabButton.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    }
  }

  customElements.define("component-tabs", Tabs);
}
